module.exports = __webpack_public_path__ + "fonts/Austin-Light.451da4bb.otf";